import angular from 'angular';
import excludedRoles from '../Components/ExcludedRoles/excludedRoles.component';
import excludedUsers from '../Components/ExcludedUsers/excludedUsers.component';


export default angular
    .module('app.systemConfiguration.setup', [])
    .component("excludedUsers", excludedUsers)
    .component("excludedRoles", excludedRoles)
    .name;